module.exports = __webpack_public_path__ + "img/0c6d764d934fba15eb92847d166bacb4.png";